// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__QqGDG","info":"Panel_info__RN3if","btns":"Panel_btns__rMTX0","button":"Panel_button__qAPSE"};